import React, { useEffect, useState } from "react";
import SubHeading from "../../../../atoms/SubHeading";
import moment from "moment";
import { GET_FILE } from "../../../../../api/apiFiles";
import DataTable from "react-data-table-component";
import NoData from "../../../../atoms/NoData";
import { PropagateLoader } from "react-spinners";
import Button from "../../../../atoms/Button";
import { FaDownload } from "react-icons/fa";
import { toast } from "react-toastify";
import { getResponsibleName } from "../../../../../functions/getNames";

const ViewReunion = ({ reunion, accountants, admins, empresa }) => {
    const [documentos, setDocumentos] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect( ()=> {
        const fetchDocumentos = async() => {
            setLoading(true);
            try {
                const files = reunion?.files || [];
                const response = await Promise.all(
                    files?.map(async (file) =>  {
                        const url = await GET_FILE(empresa?.id, {s3Key: file?.s3Key} );
                        return {
                            url,
                            type: file?.type,
                            s3Key: file?.s3Key,
                        };
                })
                );
                setDocumentos(response);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        fetchDocumentos();
    },[empresa.id, reunion?.files]);

    const columns = [
        {name: "Tarea", selector: row => `* ${row}`}
    ];

    const handleDownloadDocument = async (s3Key) => {
        try {
            const fileUrl = await GET_FILE(empresa?.id, { s3Key });
            const response = await fetch(fileUrl);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = s3Key;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(blobUrl);
            toast.success("Descargando");
        } catch (error) {
            console.error(error);
            toast.error("Error al descargar el archivo");
        }
    };

    const renderTextBlock = (label, text) => (
        <div className="w-full flex flex-col mb-4">
            <SubHeading text={label} color="blue" />
            <div className="px-4">
                <DataTable
                    data={text}
                    columns={columns}
                    noDataComponent={<NoData/>}
                />
            </div>
        </div>
    );

    return (
        <div className="w-full space-y-6">
            <div className="w-full flex flex-col md:flex-row gap-4">
                <div className="w-full flex flex-row space-x-4">
                    <SubHeading text="Asunto:" color="blue" />
                    <SubHeading text={reunion.subject} />
                </div>
                <div className="w-full flex flex-row space-x-4">
                    <SubHeading text="Lugar:" color="blue" />
                    <SubHeading text={reunion.location} />
                </div>
                <div className="w-full flex flex-row space-x-4">
                    <SubHeading text="Fecha y hora:" color="blue" />
                    <SubHeading text={moment(reunion.createdAt).format("DD/MM/YY HH:mm")} />
                </div>
            </div>

            <div className="w-full flex flex-col md:flex-row gap-4">
                <div className="w-full flex flex-row space-x-4">
                    <SubHeading text="Empresa:" color="blue" />
                    <SubHeading text={empresa.name} />
                </div>
                <div className="w-full flex flex-row space-x-4">
                    <SubHeading text="Contador:" color="blue" />
                    <SubHeading text={getResponsibleName(empresa, accountants, admins)} />
                </div>
            </div>

            {(reunion?.members?.rs?.length > 0 || reunion?.members?.ext?.length > 0) && (
                <div className="w-full flex flex-col md:flex-row space-y-6 md:space-y-0">
                    {reunion?.members?.rs?.length > 0 && (
                    <div className="w-full">
                        <SubHeading text="Miembros Internos" color="blue" />
                        <ul className="list-disc ml-6">
                        {reunion.members.rs.map((member) => (
                            <li key={member.id}>
                            <p><strong>Nombre:</strong> {member.name}</p>
                            <p><strong>Email:</strong> {member.email}</p>
                            </li>
                        ))}
                        </ul>
                    </div>
                    )}

                    {reunion?.members?.ext?.length > 0 && (
                    <div className="w-full">
                        <SubHeading text="Miembros Externos" color="blue" />
                        <ul className="list-disc ml-6">
                        {reunion.members.ext.map((member) => (
                            <li key={member.id}>
                            <p><strong>Nombre:</strong> {member.name}</p>
                            <p><strong>Email:</strong> {member.email}</p>
                            </li>
                        ))}
                        </ul>
                    </div>
                    )}
                </div>
            )}

            {renderTextBlock("Reunión:", reunion.body)}
            <div className="flex flex-col md:flex-row">
                {renderTextBlock("Tareas despacho:", reunion.office_tasks)}
                {renderTextBlock("Tareas cliente:", reunion.client_tasks)}
            </div>
            <div className="w-full flex flex-col space-y-4 justify-center items-center">
                {loading ?
                    <PropagateLoader color="red" />
                :
                (documentos.length > 0 && (
                    [...documentos]
                    .sort((a ,b) =>{
                        if (a.type === "photo" && b.type !== "photo") return 1;
                        if (a.type !== "photo" && b.type === "photo") return -1;
                        return 0;
                    })
                    .map((doc, index) => (
                        (doc.type !== "photo" ? 
                                <iframe src={doc.url} className="h-[80vh] w-full" title={`Documento ${index + 1}`} />
                            :
                                <div className="w-2/3 flex flex-row justify-center items-center space-x-6">
                                    <img src={doc.url} alt="imagen" className="rounded-lg w-full h-auto" />
                                    <Button width="w-12" text={<FaDownload size={27} />} bgColor="green" onClick={()=>handleDownloadDocument(doc.s3Key)} />
                                </div>
                        )
                    ))
                ))}
            </div>
        </div>
    );
};

export default ViewReunion;
